import { TachographDueSettings } from "../models/Tachograph";
import { DEFAULT_DEVICE_INTERVAL_DAYS, DEFAULT_DRIVER_INTERVAL_DAYS } from "./tachographPolicy";

/** A readout is flagged this many days before it is due. */
export const DEFAULT_WARNING_DAYS = 30;

export const MAX_INTERVAL_DAYS = 3650;
export const MAX_WARNING_DAYS = 365;

/**
 * The legal deadlines (§ 2 Abs. 5 FPersV, EU 2016/799): vehicle units every 90 days, driver
 * cards every 28 days. Not the database's own download period: Geotab keeps the remote download
 * cycle there (often one day), which is a schedule, not a deadline.
 */
export const DEFAULT_DUE_SETTINGS: TachographDueSettings = {
  deviceIntervalDays: DEFAULT_DEVICE_INTERVAL_DAYS,
  driverIntervalDays: DEFAULT_DRIVER_INTERVAL_DAYS,
  warningDays: DEFAULT_WARNING_DAYS,
  highlightRows: true,
};

const wholeDaysIn = (value: unknown, min: number, max: number): number | null =>
  typeof value === "number" && Number.isInteger(value) && value >= min && value <= max ? value : null;

/** The stored settings with every missing or broken value replaced by its default. */
export function normalizeDueSettings(stored: Partial<TachographDueSettings> | undefined): TachographDueSettings {
  return {
    deviceIntervalDays:
      wholeDaysIn(stored?.deviceIntervalDays, 1, MAX_INTERVAL_DAYS) ?? DEFAULT_DUE_SETTINGS.deviceIntervalDays,
    driverIntervalDays:
      wholeDaysIn(stored?.driverIntervalDays, 1, MAX_INTERVAL_DAYS) ?? DEFAULT_DUE_SETTINGS.driverIntervalDays,
    warningDays: wholeDaysIn(stored?.warningDays, 0, MAX_WARNING_DAYS) ?? DEFAULT_DUE_SETTINGS.warningDays,
    highlightRows:
      typeof stored?.highlightRows === "boolean" ? stored.highlightRows : DEFAULT_DUE_SETTINGS.highlightRows,
  };
}
